import { myIcons } from "@/utils/icons";
import { t } from "i18next";
import { Tooltip } from 'antd';
import rawStatics from "@/utils/statics.json";
import { Statics } from "@/pages/Home/TopArea";
const statics = rawStatics as Statics;

export const Footer = () => {
    return (
        <footer style={{
            backgroundColor: "#1a1a1a",
            color: "#f5f5f5",
            display: "flex",
            flexDirection: 'column',
            width: '100%'
        }}>
            <div
                style={{
                    backgroundColor: "#1a1a1a",
                    color: "#f5f5f5",
                    padding: "20px 40px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                    margin: 0,
                    width: '100%'
                }}>
                {/* Sol kısım */}
                <div style={{ fontSize: "1.1rem" }}>
                    {statics.myName}
                </div>

                {/* Orta kısım */}
                <div style={{ fontSize: "0.9rem", opacity: 0.8 }}>
                    © {new Date().getFullYear()} {t('footer-copyright')}
                </div>

                {/* Sağ kısım */}
                <div className="socials"
                    style={{
                        display: 'flex',
                        gap: '10px'
                    }}
                >
                    {statics.socials.map((item) => (
                        <a
                            key={item.id}
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                style={{
                                    width: '35px',
                                    height: '35px'
                                }}
                                src={`${statics.iconBaseUrl}${item.id}.svg`}
                                alt={item.id}
                            />
                        </a>
                    ))}
                </div>
            </div>
            <div
                style={{
                    backgroundColor: 'black',
                    padding: '5px',
                    fontSize: "0.9rem",
                    textAlign: 'center',
                }}
            >
                <Tooltip title={t("testingText")}>
                    <p className="blinking-red"
                    >Test aşamasındadır
                    </p>
                </Tooltip>
            </div>
        </footer >
    );
};
